var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3,
    fill: "#3F55FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6615 16.5334C24.812 15.9939 24.812 14.3562 23.6608 13.8174L9.59859 7.22503C8.44389 6.68409 7.18453 7.73839 7.51263 8.97017L8.90068 14.1752L14.788 14.1752C15.0502 14.1797 15.3001 14.2871 15.4839 14.4741C15.6677 14.6611 15.7707 14.9128 15.7707 15.175C15.7707 15.4372 15.6677 15.689 15.4839 15.876C15.3001 16.063 15.0502 16.1703 14.788 16.1749H8.90068L7.51334 21.3806C7.18453 22.6117 8.44459 23.6653 9.59859 23.125L23.6615 16.5334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendlogo);
export default __webpack_public_path__ + "static/media/sendlogo.cfaf5642a4fb99df9c5ab3abc6ec6c90.svg";
export { ForwardRef as ReactComponent };